(function () {
  'use strict';

  var RATE = 1.95583;
  var CART_SECTION_ID = 'cart-drawer';
  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = null;
  var panel = null;
  var lastFocused = null;
  var refreshPromise = null;
  var lineChangeStates = Object.create(null);
  var priceScanQueue = [];
  var priceScanTimer = null;

  function endpoint(path) {
    return rootPath.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function eurText(cents) {
    return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function bgnText(cents) {
    return ((Number(cents || 0) / 100) * RATE).toFixed(2).replace('.', ',') + ' лв';
  }

  function dualText(cents) {
    return eurText(cents) + ' / ' + bgnText(cents);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function updateCartMeta(itemCount, totalPrice) {
    itemCount = Number(itemCount || 0);
    if (drawer) {
      drawer.dataset.itemCount = String(itemCount);
      if (Number.isFinite(Number(totalPrice))) drawer.dataset.totalCents = String(Number(totalPrice));
    }

    document.querySelectorAll('.sf-cart-count, .cart-count, [data-lume-cart-count]').forEach(function (node) {
      node.textContent = itemCount;
    });

    document.body.classList.toggle('cart-empty', itemCount === 0);
    document.body.classList.toggle('cart-has-items', itemCount > 0);
  }

  function hydrateDrawerPrices() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-eur-cents]').forEach(function (node) {
      var cents = Number(node.getAttribute('data-eur-cents'));
      if (Number.isFinite(cents)) node.textContent = dualText(cents);
    });
  }

  function hydrateDrawerMarkup() {
    if (!drawer) return;
    var itemCount = Number(drawer.dataset.itemCount || 0);
    var totalCents = Number(drawer.dataset.totalCents || 0);
    updateCartMeta(itemCount, totalCents);
    hydrateDrawerPrices();
    updateProgress(totalCents);
  }

  function initDrawer() {
    drawer = document.querySelector('[data-lume-cart-drawer]');
    if (!drawer) return;
    panel = drawer.querySelector('.lume-cart-panel');

    if (drawer.dataset.lumeCartReady === 'true') {
      hydrateDrawerMarkup();
      return;
    }
    drawer.dataset.lumeCartReady = 'true';

    drawer.querySelectorAll('[data-lume-cart-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('click', function (event) {
      var quick = event.target.closest('.lume-quick-add[data-variant-id]');
      if (quick) {
        event.preventDefault();
        addVariant(Number(quick.dataset.variantId), 1, quick).catch(function (error) { console.error(error); });
        return;
      }

      var item = event.target.closest('.lume-cart-item[data-cart-key]');
      if (!item) return;
      var key = item.dataset.cartKey;
      var qtyEl = item.querySelector('.lume-cart-qty span');
      var currentQty = Number(qtyEl ? qtyEl.textContent : item.dataset.cartQuantity || 1) || 1;

      if (event.target.closest('[data-cart-qty-minus]')) {
        event.preventDefault();
        queueLineChange(item, key, Math.max(0, currentQty - 1));
      } else if (event.target.closest('[data-cart-qty-plus]')) {
        event.preventDefault();
        queueLineChange(item, key, currentQty + 1);
      } else if (event.target.closest('[data-cart-remove]')) {
        event.preventDefault();
        queueLineChange(item, key, 0);
      }
    });

    hydrateDrawerMarkup();
  }

  function openDrawer() {
    if (!drawer) initDrawer();
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        document.body.classList.add('lume-cart-open');
        var close = drawer.querySelector('.lume-cart-close');
        if (close) close.focus({ preventScroll: true });
      });
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('lume-cart-open');
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 460);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
  }

  function fetchCart() {
    return fetch(endpoint('cart.js'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function refreshDrawer(shouldOpen) {
    if (shouldOpen) openDrawer();
    if (refreshPromise) return refreshPromise;

    refreshPromise = fetchCart()
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .finally(function () {
        refreshPromise = null;
      });

    return refreshPromise;
  }

  function sectionRequestPayload(items) {
    return {
      items: items,
      sections: [CART_SECTION_ID],
      sections_url: window.location.pathname || '/'
    };
  }

  function applyCartSection(html) {
    if (!drawer || !html || !window.DOMParser) return null;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.querySelector('[data-lume-cart-drawer]');
    if (!source) return null;

    var sourceItems = source.querySelector('[data-lume-cart-items]');
    var targetItems = drawer.querySelector('[data-lume-cart-items]');
    if (sourceItems && targetItems) targetItems.innerHTML = sourceItems.innerHTML;

    var sourceLabel = source.querySelector('[data-lume-cart-count-label]');
    var targetLabel = drawer.querySelector('[data-lume-cart-count-label]');
    if (sourceLabel && targetLabel) targetLabel.textContent = sourceLabel.textContent;

    var sourceSubtotal = source.querySelector('[data-lume-cart-subtotal]');
    var targetSubtotal = drawer.querySelector('[data-lume-cart-subtotal]');
    if (sourceSubtotal && targetSubtotal) {
      targetSubtotal.textContent = sourceSubtotal.textContent;
      if (sourceSubtotal.hasAttribute('data-eur-cents')) {
        targetSubtotal.setAttribute('data-eur-cents', sourceSubtotal.getAttribute('data-eur-cents'));
      }
    }

    var itemCount = Number(source.dataset.itemCount || 0);
    var totalPrice = Number(source.dataset.totalCents || 0);
    updateCartMeta(itemCount, totalPrice);
    hydrateDrawerPrices();
    updateProgress(totalPrice);

    return { item_count: itemCount, total_price: totalPrice };
  }

  function addItemsRequest(items) {
    return fetch(endpoint('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(sectionRequestPayload(items))
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Add to cart failed');
        });
      }
      return response.json();
    });
  }

  function addVariant(variantId, quantity, button) {
    if (!variantId || quantity < 1) return Promise.reject(new Error('Missing variant'));
    var isComplexButton = !!(button && button.children && button.children.length);
    var originalText = button && !isComplexButton ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      if (!isComplexButton) button.textContent = 'Добавяне…';
    }

    return addItems([{ id: Number(variantId), quantity: Number(quantity) }], true)
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
          if (!isComplexButton) button.textContent = originalText;
        }
      });
  }

  function addItems(items, shouldOpen) {
    if (!Array.isArray(items) || !items.length) return Promise.reject(new Error('No cart items'));

    return addItemsRequest(items).then(function (response) {
      var rendered = response.sections && applyCartSection(response.sections[CART_SECTION_ID]);
      if (rendered) {
        if (shouldOpen !== false) openDrawer();
        return rendered;
      }

      return refreshDrawer(shouldOpen !== false);
    });
  }


  function findCartItem(key) {
    if (!drawer) return null;
    var items = drawer.querySelectorAll('.lume-cart-item[data-cart-key]');
    for (var i = 0; i < items.length; i++) {
      if (items[i].dataset.cartKey === String(key)) return items[i];
    }
    return null;
  }

  function requestLineChange(key, quantity) {
    return fetch(endpoint('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function setLineBusy(key, busy) {
    if (!drawer) return;
    var item = findCartItem(key);
    if (!item) return;
    item.setAttribute('aria-busy', busy ? 'true' : 'false');
    item.querySelectorAll('button').forEach(function (button) { button.disabled = !!busy; });
  }

  function applyOptimisticQuantity(key, quantity) {
    if (!drawer) return;
    var item = findCartItem(key);
    if (!item) return;
    var qty = item.querySelector('.lume-cart-qty span');
    if (qty && quantity > 0) qty.textContent = quantity;
    item.dataset.cartQuantity = String(quantity);
  }

  function queueLineChange(item, key, quantity) {
    if (!key) return;
    quantity = Math.max(0, Number(quantity || 0));
    var qtyEl = item && item.querySelector('.lume-cart-qty span');
    var currentQty = Number(qtyEl ? qtyEl.textContent : item && item.dataset.cartQuantity || 1) || 1;
    var state = lineChangeStates[key];

    if (!state) {
      state = lineChangeStates[key] = {
        confirmed: currentQty,
        desired: currentQty,
        sent: null,
        inFlight: false,
        timer: null
      };
    }

    state.desired = quantity;
    if (qtyEl && quantity > 0) qtyEl.textContent = quantity;
    if (item) item.dataset.cartQuantity = String(quantity);

    window.clearTimeout(state.timer);
    if (!state.inFlight) {
      state.timer = window.setTimeout(function () { flushLineChange(key); }, quantity === 0 ? 0 : 110);
    }
  }

  function flushLineChange(key) {
    var state = lineChangeStates[key];
    if (!state || state.inFlight) return;
    if (state.desired === state.confirmed) {
      delete lineChangeStates[key];
      return;
    }

    state.inFlight = true;
    state.sent = state.desired;
    setLineBusy(key, true);

    requestLineChange(key, state.sent)
      .then(function (cart) {
        state.confirmed = state.sent;
        state.inFlight = false;
        renderCart(cart);

        if (state.desired !== state.confirmed) {
          applyOptimisticQuantity(key, state.desired);
          window.setTimeout(function () { flushLineChange(key); }, 0);
        } else {
          delete lineChangeStates[key];
        }
      })
      .catch(function (error) {
        console.error(error);
        delete lineChangeStates[key];
        refreshDrawer(false).catch(function (refreshError) { console.error(refreshError); });
      });
  }

  function renderCart(cart) {
    if (!drawer || !cart) return;
    var itemsRoot = drawer.querySelector('[data-lume-cart-items]');
    var subtotal = drawer.querySelector('[data-lume-cart-subtotal]');
    var label = drawer.querySelector('[data-lume-cart-count-label]');
    var singular = drawer.dataset.titleSingular || 'продукт';
    var plural = drawer.dataset.titlePlural || 'продукта';

    if (label) label.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? singular : plural);
    if (subtotal) {
      subtotal.setAttribute('data-eur-cents', String(cart.total_price));
      subtotal.textContent = dualText(cart.total_price);
    }

    updateCartMeta(cart.item_count, cart.total_price);

    if (itemsRoot) {
      if (!cart.items.length) {
        var emptyText = drawer.dataset.emptyText || 'Количката ти е празна.';
        var emptyButtonLabel = drawer.dataset.emptyButtonLabel || 'Разгледай продуктите';
        var emptyButtonLink = drawer.dataset.emptyButtonLink || '/collections/all';
        itemsRoot.innerHTML = '<div class="lume-cart-empty"><p>' + escapeHtml(emptyText) + '</p><a href="' + escapeHtml(emptyButtonLink) + '">' + escapeHtml(emptyButtonLabel) + '</a></div>';
      } else {
        itemsRoot.innerHTML = cart.items.map(function (item) {
          var imageUrl = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
          var image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" decoding="async">' : '';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="lume-cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
          var removeLabel = drawer.dataset.removeLabel || 'Премахни';
          return '<article class="lume-cart-item" data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity="' + item.quantity + '">' +
            '<a class="lume-cart-item-image" href="' + escapeHtml(item.url) + '">' + image + '</a>' +
            '<div><a class="lume-cart-item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant +
            '<div class="lume-cart-item-actions"><div class="lume-cart-qty"><button type="button" data-cart-qty-minus>−</button><span>' + item.quantity + '</span><button type="button" data-cart-qty-plus>+</button></div><button class="lume-cart-remove" type="button" data-cart-remove>' + escapeHtml(removeLabel) + '</button></div></div>' +
            '<div class="lume-cart-item-price" data-eur-cents="' + item.final_line_price + '">' + dualText(item.final_line_price) + '</div></article>';
        }).join('');
      }
    }

    updateProgress(cart.total_price);
  }

  function updateProgress(totalCents) {
    if (!drawer) return;
    var wrap = drawer.querySelector('[data-lume-cart-progress-wrap]');
    if (!wrap) return;
    var threshold = Number(drawer.dataset.thresholdCents || 0);
    var text = wrap.querySelector('[data-lume-cart-progress-text]');
    var bar = wrap.querySelector('[data-lume-cart-progress-bar]');
    if (!threshold) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    var remaining = Math.max(0, threshold - Number(totalCents || 0));
    var progress = Math.min(100, Math.max(0, Number(totalCents || 0) / threshold * 100));
    if (bar) bar.style.width = progress + '%';
    if (text) {
      if (remaining <= 0) {
        text.textContent = drawer.dataset.progressReached || 'Имаш безплатна доставка';
      } else {
        var template = drawer.dataset.progressTemplate || 'Добави още [amount] за безплатна доставка';
        text.textContent = template.replace('[amount]', dualText(remaining));
      }
    }
  }

  function formItems(form) {
    var data = new FormData(form);
    var id = Number(data.get('id'));
    var quantity = Number(data.get('quantity') || 1);
    if (!id) return [];
    var item = { id: id, quantity: quantity > 0 ? quantity : 1 };
    var properties = {};
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
    return [item];
  }

  function initGlobalCartEvents() {
    document.addEventListener('click', function (event) {
      var directAtc = event.target.closest('button.add-to-cart[type="button"]');
      if (!directAtc) return;
      var directForm = directAtc.closest('form[action*="/cart/add"]');
      if (!directForm) return;
      var directItems = formItems(directForm);
      if (!directItems.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      directAtc.disabled = true;
      addItems(directItems, true)
        .catch(function (error) { console.error(error); })
        .finally(function () { directAtc.disabled = false; });
    }, true);

    document.addEventListener('click', function (event) {
      var cartTrigger = event.target.closest('.lume-cart-trigger, [data-lume-cart-open], .cart-btn');
      if (cartTrigger) {
        event.preventDefault();
        openDrawer();
        refreshDrawer(false).catch(function (error) { console.error(error); });
        return;
      }

      var quick = event.target.closest('.lume-quick-add[data-variant-id]');
      if (quick && (!drawer || !drawer.contains(quick))) {
        event.preventDefault();
        addVariant(Number(quick.dataset.variantId), Number(quick.dataset.quantity || 1), quick).catch(function (error) { console.error(error); });
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (form.hasAttribute('data-lume-native-cart')) return;
      var items = formItems(form);
      if (!items.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addItems(items, true).catch(function (error) { console.error(error); });
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshDrawer(false).catch(function () {});
    });
  }

  function euroMatch(text) {
    if (!text || /(?:лв\.?|BGN)/i.test(text)) return null;
    var match = text.match(/(?:€|EUR\b)\s*([0-9]+(?:[.,][0-9]{1,2})?)|([0-9]+(?:[.,][0-9]{1,2})?)\s*(?:€|EUR\b)/i);
    if (!match) return null;
    var raw = match[1] || match[2];
    var value = Number(String(raw).replace(',', '.'));
    if (!Number.isFinite(value)) return null;
    return { value: value, index: match.index || 0, length: match[0].length };
  }

  function parseEuro(text) {
    var found = euroMatch(text);
    return found ? found.value : null;
  }

  function hasNearbyBgn(parent) {
    if (!parent) return false;
    var siblings = [parent.previousElementSibling, parent.nextElementSibling];
    if (siblings.some(function (el) { return el && /(?:лв\.?|BGN)/i.test(el.textContent || ''); })) return true;
    var container = parent.parentElement;
    if (!container || container.children.length > 12) return false;
    return Array.prototype.some.call(container.children, function (child) {
      return child !== parent && /(?:лв\.?|BGN)/i.test(child.textContent || '');
    });
  }

  function convertPriceTextNode(node) {
    if (!node || node.nodeType !== 3 || !node.parentElement) return;
    var parent = node.parentElement;
    if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|OPTION)$/i.test(parent.tagName)) return;
    if (parent.closest('[data-no-dual-price], .lume-bgn-price')) return;
    if (/(?:лв\.?|BGN)/i.test(parent.textContent || '')) return;
    if (parent.querySelector && parent.querySelector(':scope > .lume-bgn-price')) return;
    if (hasNearbyBgn(parent)) return;

    var found = euroMatch(node.nodeValue);
    if (!found) return;
    var original = node.nodeValue;
    var cut = found.index + found.length;
    var suffix = original.slice(cut);
    node.nodeValue = original.slice(0, cut);
    var span = document.createElement('span');
    span.className = 'lume-bgn-price';
    span.textContent = ' / ' + (found.value * RATE).toFixed(2).replace('.', ',') + ' лв';
    node.parentNode.insertBefore(span, node.nextSibling);
    if (suffix) span.parentNode.insertBefore(document.createTextNode(suffix), span.nextSibling);
  }

  function scanDualPrices(scope) {
    var target = scope && scope.nodeType ? scope : document.body;
    if (!target) return;
    if (target.nodeType === 3) {
      convertPriceTextNode(target);
      return;
    }
    if (!document.createTreeWalker) return;

    var walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(convertPriceTextNode);
  }

  function processPriceScanQueue() {
    priceScanTimer = null;
    var queue = priceScanQueue.slice();
    priceScanQueue.length = 0;

    queue.forEach(function (node, index) {
      if (!node || !node.isConnected) return;
      for (var i = 0; i < index; i++) {
        var previous = queue[i];
        if (previous && previous.nodeType === 1 && previous.contains(node)) return;
      }
      scanDualPrices(node);
    });
  }

  function scheduleDualPriceScan(scope) {
    var node = scope && scope.nodeType ? scope : document.body;
    if (!node) return;
    priceScanQueue.push(node);
    if (priceScanTimer) return;
    priceScanTimer = window.setTimeout(processPriceScanQueue, 40);
  }

  function initDualPricingObserver() {
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            Array.prototype.forEach.call(mutation.addedNodes, function (node) {
              if (node.nodeType === 1 && node.classList && node.classList.contains('lume-bgn-price')) return;
              scheduleDualPriceScan(node);
            });
          } else if (mutation.type === 'characterData') {
            var parent = mutation.target.parentElement;
            if (!parent || parent.closest('.lume-bgn-price')) return;
            var found = euroMatch(mutation.target.nodeValue || '');
            var next = mutation.target.nextSibling;
            if (found && next && next.nodeType === 1 && next.classList.contains('lume-bgn-price')) {
              next.textContent = ' / ' + (found.value * RATE).toFixed(2).replace('.', ',') + ' лв';
            } else if (found) {
              scheduleDualPriceScan(mutation.target);
            }
          }
        });
      });
      observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    }

    requestAnimationFrame(function () { scanDualPrices(document.body); });
  }

  function initRevealObserver() {
    if (document.documentElement.dataset.template === 'index') return;
    var elements = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (!elements.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (element) { element.classList.add('in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '80px 0px' });

    elements.forEach(function (element) { observer.observe(element); });
  }

  window.LumeDualPrices = {
    scan: function (scope) { scanDualPrices(scope || document.body); },
    rate: RATE
  };

  function boot() {
    initDrawer();
    initGlobalCartEvents();
    initDualPricingObserver();
    initRevealObserver();
    window.LumeCart = {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshDrawer,
      add: addVariant,
      addItems: addItems,
      dualText: dualText
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
